// extracted by mini-css-extract-plugin
export default {"CuisineLink":"pL3m685WNAMSBwKxfyLB","CuisineLinkContainer":"dYwqSnmA2XWiTxQFiv2r","CuisineLink_emoji":"K5BepCq9peleKBrBBoS5"};